<div class="form-field">
  <label *ngIf="!noLabel" [for]="id">{{ label }}</label>
  <div class="input-content" [class.with-prefix]="!!prefixIcon">
    <div *ngIf="prefixIcon" class="prefix-icon" aria-hidden="true">
      <mat-icon>{{ prefixIcon }}</mat-icon>
    </div>
    <ng-container *ngIf="type !== 'textarea'; else textareaBlock">
      <ng-container *ngIf="autocompleteAnchor">
        <input
          [class.invalid]="!!error"
          [class.with-prefix]="!!prefixIcon"
          [class.size-small]="size === 'small'"
          [id]="id"
          [type]="!passwordInput ? type : visibleValue ? 'text' : 'password'"
          [placeholder]="placeholder ?? ''"
          [value]="value"
          (input)="emitChange($any($event.target).value)"
          (focus)="emitFocus()"
          (focusout)="emitFocusOut()"
          [readOnly]="readonly"
          [matAutocomplete]="autocompleteAnchor"
          [mask]="mask"
          [style.cursor]="readonly ? 'not-allowed' : 'default'"
        />
      </ng-container>
      <ng-container *ngIf="!autocompleteAnchor">
        <input
          [class.invalid]="!!error"
          [class.with-prefix]="!!prefixIcon"
          [class.size-small]="size === 'small'"
          [id]="id"
          [type]="!passwordInput ? type : visibleValue ? 'text' : 'password'"
          [placeholder]="placeholder ?? ''"
          [value]="value"
          (input)="emitChange($any($event.target).value)"
          (focus)="emitFocus()"
          (focusout)="emitFocusOut()"
          [readOnly]="readonly"
          [mask]="mask"
          [style.cursor]="readonly ? 'not-allowed' : 'default'"
        />
      </ng-container>
    </ng-container>
    <ng-template #textareaBlock>
  <textarea
        [class.invalid]="!!error"
        [class.with-prefix]="!!prefixIcon"
        [class.size-small]="size === 'small'"
        [id]="id"
        [placeholder]="placeholder ?? ''"
        [value]="value"
        (input)="emitChange($any($event.target).value)"
        (focus)="emitFocus()"
        (focusout)="emitFocusOut()"
        [readOnly]="readonly"
        [mask]="mask"
        [style.cursor]="readonly ? 'not-allowed' : 'default'"
        rows="1"
        #autoGrowTextarea
        (input)="autoGrow(autoGrowTextarea)"
        (keydown)="onTextareaKeydown($event)"
      ></textarea>
    </ng-template>
    <button
      *ngIf="passwordInput"
      mat-icon-button
      class="password-visibility"
      (click)="visibleValue = !visibleValue"
      type="button"
    >
      <mat-icon>{{ visibleValue ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
  </div>
  <p class="hint-error" *ngIf="error">{{ error }}</p>
</div>
